// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3J7I_","footer":"ModalFilter_footer__3zLAK"};